/**
 * 상담 완료 화면 — v2 문서 버전.
 *
 * 프로덕션의 `CounselCompleteScreen` 에 대응한다. 화면 자체는 아주 단순하다 — 가운데
 * 축하 블록 하나와 하단 버튼 하나. 대신 마운트되자마자 세션 리뷰 확정 → 상담 종료 →
 * 다음 일정 조회를 순서대로 부르고, 그 결과가 버튼 문구를 가른다.
 *
 * 그 순서를 `onEnter` 액션으로 옮겼다. 화면이 뜰 때 부수효과가 있다는 사실이 문서에
 * 적혀 있어야, 편집자가 "여기서 상담이 실제로 닫힌다" 를 알 수 있다.
 */
import type { AssetDocument } from "@miso/design-system";

const doc: AssetDocument = {
  id: "counsel.complete",
  schemaVersion: 2,
  initial: "done",
  steps: {
    done: {
      kind: "screen",
      onEnter: [
        { do: "callAction", name: "counsel.markSessionReviewed" },
        { do: "callAction", name: "counsel.complete" },
        {
          do: "callAction",
          name: "counsel.fetchNextSchedule",
          resultAs: "nextCounselId",
        },
      ],
      layout: {
        type: "Screen",
        props: { variant: "cover" },
        slots: {
          footer: [
            {
              type: "CtaButton",
              props: { label: "다음 일정 확인하기" },
              visibleWhen: { not: { isEmpty: { var: "nextCounselId" } } },
              on: { onPress: [{ do: "submit" }] },
            },
            {
              type: "CtaButton",
              props: { label: "내 일정으로 돌아가기" },
              visibleWhen: { isEmpty: { var: "nextCounselId" } },
              on: { onPress: [{ do: "submit" }] },
            },
          ],
        },
        children: [
          {
            type: "Cover",
            props: {
              emoji: "🎉",
              emojiLabel: "축하",
              title: "상담이 완료되었어요!",
              description: "수고하셨습니다.",
            },
          },
        ],
      },
      next: { kind: "exit" },
    },
  },
};

const initialValues: Record<string, unknown> = { nextCounselId: null };

export const COUNSEL_COMPLETE = { doc, initialValues };
